import type {LessonId, LessonSlideId} from 'course/lessons/lessonTypes';
import {
  doc,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  getDoc,
  getFirestore,
  type DocumentReference,
  type FirestoreDataConverter,
} from 'firebase/firestore';
import type {CourseId, UserId} from 'types/common';

/**
 * A map tracking an individual user's lesson progress.
 */
export interface UserLessonsProgressMap {
  /**
   * Each key represents progress either on the entire lesson or on a specific
   * slide within the lesson.
   */
  [itemId: LessonId | `${LessonId}/${LessonSlideId}`]: boolean;
}

const isUserLessonsProgressMap = (
  data: unknown,
): data is UserLessonsProgressMap => {
  return (
    typeof data === 'object' &&
    data !== null &&
    Object.values(data).every(value => typeof value === 'boolean')
  );
};

const getUserLessonsProgressMapFirebasePath = ({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}) => `users/${userId}/${courseId}/lessonsProgress`;

const userLessonsProgressMapConverter: FirestoreDataConverter<UserLessonsProgressMap> =
  {
    toFirestore: data => data,
    fromFirestore: snapshot => {
      const data = snapshot.data();
      if (!isUserLessonsProgressMap(data)) {
        throw new Error('Invalid user lessons progress map');
      }
      return data;
    },
  };

export const getUserLessonsProgressMapRef = ({
  userId,
  courseId,
}: {
  userId: UserId;
  courseId: CourseId;
}): DocumentReference<UserLessonsProgressMap> => {
  return doc(
    getFirestore(),
    getUserLessonsProgressMapFirebasePath({userId, courseId}),
  ).withConverter(userLessonsProgressMapConverter);
};
